import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { UrlService } from '@core/services/url/url.service';
import { CustomFormSubmission, CustomFormFieldSubmission } from '@core/objects/form';
import { FieldSubmissionPayloadInterface } from '@core/custom-forms/models/submissions/submissions-custom-form-field-data.model';

import { CoreResponseUtilsService } from '@core/services/utils/response-utils.service';

@Injectable({
    providedIn: 'root'
})
export class ProjectsCustomFormsRequests {

    private readonly prefix = "/projects/";

    // todo set here the payload to test.
    // public readonly payloadTest = {
    //     "values": [
    //         {
    //             "alias": "some_alias",
    //             "value": "some value"
    //         },
            
    //     ]
    // };

    constructor(private http: HttpClient, private urlSrv: UrlService,
        private responseUtilsSrv: CoreResponseUtilsService
    ) { }

    public getForms$ = (projectId: number): Observable<CustomFormSubmission[]> =>
        this.http.get<CustomFormSubmission[]>(this.urlSrv.build(this.prefix + projectId + '/forms'));
        // this.responseUtilsSrv.simulate500InternalServerError()
        // this.responseUtilsSrv.simulate200SuccessResponse([] as CustomFormSubmission[]).pipe(
        //     map(response => response.body as CustomFormSubmission[])
        // );  

    public getFieldSubmissions$ = (projectId: number, formId: string): Observable<CustomFormFieldSubmission[]> =>
        this.http.get<CustomFormFieldSubmission[]>(this.urlSrv.build(this.prefix + projectId + '/forms/' + formId + "/submissions"));

        // public loadFieldsValues$ = (id: string): Observable<FieldDataInterfaceValue[]> =>{
        //   // return this.responseUtilsSrv.simulate200SuccessResponse([] as FieldDataInterfaceValue[])
        //   return this.responseUtilsSrv.simulate200SuccessResponse<FieldDataInterfaceValue[]>([]).pipe(
        //     map(response => response.body as FieldDataInterfaceValue[])
        //   );
        // }
        // this.http.get<FieldDataInterface[]>(this.urlSrv.build(this.prefix + "/" +id+ "/fields/values"));

    public saveFieldsValues$ = (projectId: number, formId: string, fieldsValues: FieldSubmissionPayloadInterface[]) =>
        this.http.post(
            this.urlSrv.build(this.prefix + projectId + '/forms/' + formId + "/submissions"), 
            { values: fieldsValues }, // use this.payloadTest here fieldsValues
            { headers: new HttpHeaders({ 'Content-Type':  'application/json'}) }
        );
    
}